/**
 * @generated SignedSource<<e81eeeaddafda66279e136ad03e3a2d0>>
 * @relayHash 7c6b98448a3afa66f672bacd11624eeb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9ce11b5aaf663dbb19865b800a4b257c4a8a7cada26dc5b9a182dacdb664ab43

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CaseNoteEditPageQuery } from './CaseNoteEditPageQuery.graphql';

const node: PreloadableConcreteRequest<CaseNoteEditPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "9ce11b5aaf663dbb19865b800a4b257c4a8a7cada26dc5b9a182dacdb664ab43",
    "metadata": {},
    "name": "CaseNoteEditPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
